import React, { useState } from "react";
import { motion } from "framer-motion";
import ArrowDown from "@material-ui/icons/KeyboardArrowDown";

function Work({ data }) {
  const [toggled, settoggled] = useState(false);

  return (
    <motion.li
      className="li_ind_workexp"
      animate={{
        maxHeight: toggled
          ? data.status.length > 1
            ? "320px"
            : "170px"
          : "170px",
      }}
    >
      <motion.div
        className="div_ind_workexp"
        animate={{
          maxHeight: toggled
            ? data.status.length > 1
              ? "320px"
              : "170px"
            : "170px",
        }}
      >
        {[...data.status].reverse().map((mp, ii) => {
          return (
            <motion.div
              key={ii}
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                paddingBottom: "20px",
              }}
              initial={{
                scale: ii === 0 ? 1 : toggled ? 1 : 0,
                paddingBottom: toggled ? "20px" : "0px",
              }}
              animate={{
                scale: ii === 0 ? 1 : toggled ? 1 : 0,
                paddingBottom: toggled ? "20px" : "0px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "start",
                  gap: "10px",
                }}
              >
                <motion.p
                  className={
                    ii === 0 ? "p_label_position" : "p_label_past_position"
                  }
                >
                  {mp.position}
                </motion.p>
                {data.status.length > 1 && ii === 0 && (
                  <>
                    <motion.span
                      className="span_status_length"
                      animate={{
                        scale: toggled ? 0 : 1,
                      }}
                    >
                      +{data.status.length - 1}
                    </motion.span>
                    <div className="div_flexed" />
                    <motion.span
                      initial={{
                        rotate: 0,
                      }}
                      animate={{
                        rotate: toggled ? 180 : 0,
                      }}
                      className="btn_toggle"
                      onClick={() => {
                        settoggled(!toggled);
                      }}
                    >
                      <ArrowDown style={{ fontSize: "30px" }} />
                    </motion.span>
                  </>
                )}
              </div>
              <p className="p_label_duration">{mp.duration}</p>
            </motion.div>
          );
        })}
        <div className="div_flexed"></div>
        <p className="p_label_company">{data.company}</p>
        <p className="p_label_duration">{data.overall_duration}</p>
      </motion.div>
    </motion.li>
  );
}

export default Work;
